import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface FlooringProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Flooring: React.FC<FlooringProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [flooring, setFlooring] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Flooring'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Flooring: v } } })
    );
    const label = 'Flooring';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={flooring}
                />
            ) : (
                <TextBox
                    value={flooring ?? ''}
                    onChange={(value) => setFlooring(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
